module.exports = __webpack_public_path__ + "static/media/pail-1.9c30c3f9.png";